import { Routes } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { Login } from './pages/login/login';
import { Home } from './pages/home/home';
import { EMPRESA_ROUTES } from './pages/empresa/empresa.routes';
import { PROYECTOS_ROUTES } from './pages/proyectos/proyectos.routes';
import { PROVEEDORES_ROUTES } from './pages/proveedores/proveedores.routes';
import { POTENCIALES_PROYECTOS_ROUTES } from './pages/potenciales-proyectos/potenciales-proyectos.routes';
import { GESTION_FINANCIERA } from './pages/gestion-financiera-proyectos/gestion-financiera.routes';
import { USUARIOS_ROUTES } from './pages/usuarios/usuarios.routes';
import { AuthGuard } from '../app/core/guards/auth.guard';

export const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },

  {
    path: 'login',
    component: Login
  },

  {
    path: '',
    component: MainComponent,
    children: [
      { path: 'home', component: Home,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      }, 

      {
        path: 'potenciales-proyectos',
        children: POTENCIALES_PROYECTOS_ROUTES,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
      {
        path: 'empresas',
        children: EMPRESA_ROUTES,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
      {
        path: 'proyectos',
        children: PROYECTOS_ROUTES,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
      {
        path: 'proveedores',
        children: PROVEEDORES_ROUTES,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
      {
        path: 'gestion-financiera',
        children: GESTION_FINANCIERA,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
      {
        path: 'usuarios',
        children: USUARIOS_ROUTES,
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
      },
    ]
  }
];


